
import axios from 'axios'

import queryStringUtil from "query-string";
import dayjs from "dayjs-ext";
import treeHelper from "../util/treeHelper"
import preferences from "../util/preferences"

// eslint-disable-next-line no-unused-vars
function queryString(query) {
    var startDate = dayjs(query.dateRange[0]).format(
        "YYYY-MM-DD HH:mm:ss"
    );
    var endDate = dayjs(query.dateRange[1]).format(
        "YYYY-MM-DD HH:mm:ss"
    );
    var queryParams = {
        minValueActive: query.minValueActive,
        maxValueActive: query.maxValueActive,
        telemetry: query.telemetry,
        minValue: query.minValue,
        maxValue: query.maxValue,
        page: query.page,
        pageSize: query.pageSize,
        startDate: startDate,
        endDate: endDate,
        macAddress: query.macAddress,
        points: query.points.join(','),
        tags: query.tags.join(','),
        partial: query.partial,
        measurementType: query.measurementType,
        error: query.error,
        onlyMine: query.onlyMine,
        upload: query.upload,
        favorite: query.favorite
    };
    return queryStringUtil.stringify(queryParams, {
        arrayFormat: "bracket"
    });
}
function getTags() {
    var urlString = `${process.env.VUE_APP_APIURL}/measurement/tags`;
    return axios
        .get(urlString)
        .then(res => res.data)
}

function deleteMeasurements(query) {
    var urlString = `${process.env.VUE_APP_APIURL}/measurements`;
    return axios
        .delete(urlString, { data: { query: query } })
        .then(res => res.data)
}

function getTrend(pointId, dateRange, filters, measurementType) {
    let postDateRange = [dayjs(dateRange[0]).format(
        "YYYY-MM-DD HH:mm:ss"
    ), dayjs(dateRange[1]).format(
        "YYYY-MM-DD HH:mm:ss"
    )]
    // console.log(filters)
    return axios.get(
        `${process.env.VUE_APP_APIURL}/point/${pointId}/trend`
        , {
            params: {
                startDate: postDateRange[0],
                endDate: postDateRange[1],
                filters: filters,
                measurementType: measurementType
            }
        }).then((results) => {
            return results.data;
        });
}

function generateLink({ measurementId, allowTrend, allowImage, allowAlarmTransactions, expiresIn }) {
    return axios.post(`${process.env.VUE_APP_APIURL}/temporaryToken/measurement`, { measurementId, allowTrend, allowImage, allowAlarmTransactions, expiresIn })
        .then(response => response.data);
}
function getMeasurement(id) {
    return new Promise((res, rej) => {
        return axios
            .get(`${process.env.VUE_APP_APIURL}/measurement/` + id)
            .then((response) => {
                let measurement = response.data;
                measurement.type = measurement.measurementType

                measurement.partial = measurement.partial
                    ? "Partial"
                    : "Full";
                measurement.tags = [
                    ...new Set(measurement.tags.map((item) => item)),
                ];
                measurement.data = {};

                measurement.measurementData.map((m) =>
                    measurement.data[m.key] = m.data.map((x) => x)
                );
                res(measurement);
            })
            .catch((err) => {
                rej(err)
            });
    })
}

function searchMeasurements(query) {
    var urlString = `${process.env.VUE_APP_APIURL}/measurement?${queryString(query)}`;
    return axios
        .get(urlString)
        .then(res => {
            return {
                total: res.data.total,
                measurements: res.data.measurements.map(measurement => {
                    return {
                        id: measurement.id,
                        profileName: measurement.profile,
                        createdAt: dayjs(measurement.createdAt).format(
                            preferences().localization.dateFormat
                        ),
                        point: measurement.point,
                        user: measurement.user,
                        macAddress: measurement.macAddress,
                        gateway: measurement.gateway,
                        favorite: measurement.favorite,
                        tags: [...new Set(measurement.tags.map(item => item))],
                        measurementType: measurement.measurementType,
                        partial: measurement.partial ? "Partial" : "Full",
                        error: measurement.error
                    };
                })
            }
        })
}
export default {
    getMeasurement,
    searchMeasurements,
    getTags,
    getTrend,
    generateLink,
    deleteMeasurements
};